import type { ReactNode } from 'react';

/**
 * Generic side-panel used for Creator detail, Partnership detail, and any
 * future entity detail (Client, Project, ...). A module supplies a title
 * + arbitrary body content; it does not reimplement the slide-in panel.
 */
export function EntityDrawer({
  title,
  subtitle,
  onClose,
  children,
}: {
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} />
      <div className="drawer-panel">
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 700 }}>{title}</div>
            {subtitle && <div style={{ fontSize: 12, color: 'var(--text-3)' }}>{subtitle}</div>}
          </div>
          <button onClick={onClose}>✕</button>
        </div>
        {children}
      </div>
    </>
  );
}
